export * from './consent-proctoring-page';
export * from './contact-page';
export * from './imprint-page';
export * from './privacy-terms-page';
export * from './system-requirements-page';
export * from './terms-of-service-page';
